import React from 'react';
import * as S from './styles';

export default function InputsFeaturedFilter() {
	return (
		<S.container>
			<h1>InputsFeaturedFilter</h1>
		</S.container>
	);
}
